import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Email Fast Outline"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-email-fast-outline',
    templateUrl: './icon-email-fast-outline.component.html',
    styleUrls: ['./icon-email-fast-outline.component.scss'],
    standalone: false
})
export class IconEmailFastOutlineComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
